"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- POPUPDELETEMESSAGE : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'DeleteMessage',
  group: _definitionhelpers.groupNames.messages,
  props: {
    primaryAction: {
      type: 'function',
      default: function _default() {
        return console.log("Primary Clicked");
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;